<!-- src/components/ui/NotificationContainer.vue -->
<template>
  <Teleport to="body">
    <div class="fixed top-4 right-4 z-50 space-y-2">
      <TransitionGroup
        name="notification"
        tag="div"
        class="space-y-2"
      >
        <div
          v-for="notification in uiStore.notifications"
          :key="notification.id"
          :class="[
            'max-w-sm p-4 rounded-lg shadow-lg border',
            notificationClasses(notification.type)
          ]"
        >
          <div class="flex items-start space-x-3">
            <component 
              :is="getIcon(notification.type)" 
              class="h-5 w-5 mt-0.5 flex-shrink-0"
            />
            <div class="flex-1 min-w-0">
              <p class="text-sm font-medium">{{ notification.message }}</p>
              <p v-if="notification.description" class="text-xs mt-1 opacity-90">
                {{ notification.description }}
              </p>
            </div>
            <button
              @click="uiStore.removeNotification(notification.id)"
              class="flex-shrink-0 p-1 rounded hover:bg-black hover:bg-opacity-20"
            >
              <XMarkIcon class="h-4 w-4" />
            </button>
          </div>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup>
import { useUIStore } from '@/stores'
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XMarkIcon
} from '@heroicons/vue/24/outline'

const uiStore = useUIStore()

function notificationClasses(type) {
  const classes = {
    success: 'bg-green-900 border-green-600 text-green-100',
    error: 'bg-red-900 border-red-600 text-red-100',
    warning: 'bg-yellow-900 border-yellow-600 text-yellow-100',
    info: 'bg-blue-900 border-blue-600 text-blue-100'
  }
  return classes[type] || classes.info
}

function getIcon(type) {
  const icons = {
    success: CheckCircleIcon,
    error: ExclamationCircleIcon,
    warning: ExclamationTriangleIcon,
    info: InformationCircleIcon
  }
  return icons[type] || InformationCircleIcon
}
</script>

<style scoped>
.notification-enter-active,
.notification-leave-active {
  transition: all 0.3s ease;
}

.notification-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.notification-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.notification-move {
  transition: transform 0.3s ease;
}
</style>
